/*
 * Alt text for images the page builders render without any.
 *
 * Zipify Pages and Replo host their own copies of these images and hold the
 * alt text in their own editors, so setting it on the Shopify file does not
 * reach them and there is no API to write it. Every entry here was written by
 * looking at the image; the key is the filename the builder serves it under.
 * assets/a11y-enhancements.js applies these ONLY to an <img> that has no alt
 * attribute at all, so a value set in the builder always wins.
 *
 * An empty string is deliberate: that image is decorative and sits next to
 * visible text that already says what it says.
 *
 * The durable fix is to set alt in the Zipify and Replo editors. Until then a
 * missing entry is a missing alt, so add one when a new landing page ships.
 */
window.__a11yImageAlt = {
  "vandy-wordmark-gold.png": "Vandy",
  "vandy_icon_gold.png": "Vandy",
  "5oz-vandy-crisps-original-july-2024-12.jpeg": "Bag of Vandy Original classic potato chips on a bed of chips",
  "5oz-vandy-crisps-original-july-2024-06.png": "Bag of Vandy Original classic potato chips with chips around it",
  "5oz.jpeg": "Back of the Vandy bag: ingredients are potatoes, 100% grass-fed beef tallow and Redmond real sea salt; free of gluten, dairy, nuts and seed oils. Nutrition facts, 140 calories per 1oz serving, 5 servings per container",
  "transparent-5oz-vandy-crisps-original-july-2024-08-copy.png": "A round pile of Vandy potato chips",
  "image_67238657.jpeg": "Hand holding a stack of Vandy potato chips in a meadow",
  "1_32-1.jpeg": "Vandy potato chips scattered on a wooden board outdoors",
  "vand.png": "Vandy Classic Potato Chips",
  "ben6insta.jpeg": "Man sitting in a cold plunge tub",
  "austin.png": "Portrait of a Vandy customer",
  "amy.png": "Portrait of a Vandy customer",
  "seth-g.png": "Portrait of a Vandy customer",
  "img_9758.png": "Man at an outdoor table eating a Vandy potato chip, with the bag in front of him",
  "img_9760.png": "Vintage photograph of a man seated on a lawn in front of a large house, captioned \"Seed oils not welcome\"",
  "img_9757.png": "Vintage photograph of men in suits and hats marching with placards reading \"We want tallow\"",
  "img_9761.png": "Vintage photograph of a hand waving from a convertible, captioned \"Hop in, we're pickin up tallow fries\"",
  "img_9762.png": "Vintage photograph of figures walking past a school building, captioned \"I hear they're cooked in tallow\"",
  "img_9759.png": "Person holding a bag of Vandy potato chips and a single chip",
  "img_9764.png": "Ornate iron gates opening onto a grand estate, captioned \"Welcome. Let's get VANDY.\"",
  "img_9763.png": "Vintage illustration of a chef serving a plate of potato chips to a seated diner"
};
